import { useSelector } from "react-redux";
import useCreateOrder from "./useCreateOrder";

const usePlaceOrder = (priceDetails) => {
  const orderDetails = useSelector((state) => state.orderDetails || {});
  const {
    pickUpProducts = [],
    deliverProducts = [],
    deliveryNote = "",
    email,
    address,
    paymentMethod,
    billingAddressId = null,
    shippingAddressId,
    useAsBillingAddress: shippingSameAsBilling,
    billingAddress = null,
    termsAccepted,
  } = orderDetails;
  const { id: cartId } = useSelector((state) => state.userCart);
  const { createOrder, isOrderLoading } = useCreateOrder(
    paymentMethod,
    priceDetails,
    orderDetails
  );

  const placeOrder = () => {
    // setIsDisableCheckout(true);
    const mapProductData = (products) =>
      products.map(
        ({ isPickup, deliveryDate, storeId, pickUpDate, productId }) => ({
          isPickup,
          deliveryDate,
          storeId,
          pickUpDate,
          productId,
        })
      );

    const updatedPickUpProducts = mapProductData(pickUpProducts);
    const updatedDeliverProducts = mapProductData(deliverProducts);

    const productDetails = [
      ...updatedPickUpProducts,
      ...updatedDeliverProducts,
    ];

    const payload = {
      cartId,
      productDetails,
      deliveryNote,
      paymentMethod,
      shippingSameAsBilling,
    };
    const extraParams = {
      shippingAddressId,
      billingAddressId,
      email,
      address,
      billingAddress,
      termsAccepted,
    };
    createOrder(payload, extraParams);
  };
  return {
    placeOrder,
    isOrderLoading,
  };
};

export default usePlaceOrder;
